module.exports = __webpack_public_path__ + "./judy_0f850925331c602a5a08d9454b81f9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/judy.png
// module id = 452
// module chunks = 0